import { priorityMapping } from '../constants';

const sortByString = (
  stringA: string | undefined | null,
  stringB: string | undefined | null,
  order?: 'ASC' | 'DESC',
): number => {
  if (stringA == null || stringB == null) {
    return 0;
  }
  const isDesc = order === 'DESC';
  if (isDesc) {
    return stringB.localeCompare(stringA);
  }
  return stringA.localeCompare(stringB);
};

const sortByNumericString = (
  stringA: string | undefined | null,
  stringB: string | undefined | null,
  order?: 'ASC' | 'DESC',
): number => {
  if (stringA == null || stringB == null) {
    return 0;
  }

  if (order === 'DESC') {
    return stringB.localeCompare(stringA, 'de', { numeric: true });
  }
  return stringA.localeCompare(stringB, 'de', { numeric: true });
};

const sortByDate = (
  dateA: string | undefined | null,
  dateB: string | undefined | null,
  order?: 'ASC' | 'DESC',
): number =>
  order === 'DESC'
    ? new Date(dateB || '').getTime() - new Date(dateA || '').getTime()
    : new Date(dateA || '').getTime() - new Date(dateB || '').getTime();

const sortFhbfCaseId = (
  caseIdA: string | undefined | null,
  caseIdB: string | undefined | null,
  order?: 'ASC' | 'DESC',
): number => {
  const [, numberA, yearA] = (caseIdA || '').split('-');
  const [, numberB, yearB] = (caseIdB || '').split('-');
  if (caseIdA === caseIdB || numberA == null || numberB == null || yearA == null || yearB == null) {
    return 0;
  }

  if (yearA === yearB) {
    return order === 'ASC'
      ? numberA.localeCompare(numberB, 'de', { numeric: true })
      : numberB.localeCompare(numberA, 'de', { numeric: true });
  }
  return order === 'ASC'
    ? yearA.localeCompare(yearB, 'de', { numeric: true })
    : yearB.localeCompare(yearA, 'de', { numeric: true });
};

const sortByPriority = (
  priorityA: string | undefined | null,
  priorityB: string | undefined | null,
  order?: 'ASC' | 'DESC',
) => {
  const priorityASortOrder = priorityA != null ? priorityMapping[priorityA].sortOrder : -1;
  const priorityBSortOrder = priorityB != null ? priorityMapping[priorityB].sortOrder : -1;

  return order === 'DESC' ? priorityBSortOrder - priorityASortOrder : priorityASortOrder - priorityBSortOrder;
};

const sort = { sortByString, sortByNumericString, sortByDate, sortFhbfCaseId, sortByPriority };

export default sort;
